module.exports = __webpack_public_path__ + "static/media/bay_park.0caeac6d.jpg";